import {
    USD as USD_ADDRESS,
    USD2 as USD2_ADDRESS
} from './merchant/network'

// export const USDT = ['0x55d398326f99059fF775485246999027B3197955', 18, 'USDT']

// export const SilverAddress = '0x0A00DaAE795dC3b3f2b8a3A8dD251D95FC5648fb' 

// export const MultiCallAddress = '0x6E25E2E9d89d1Ba697B912599490268Ec0ec0724'
export const ChainName = 'BNB'
export const ChainCoinName = 'Binance Coin'
export const WBNB = ['0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', 18, 'BNB']
export const ROUTER = '0x10ED43C718714eb63d5aA57B78B54704E256024E'


// 根地址 founder 0xD7e7955FDb5F4b2784155050A9382018F90d0683

// CVC 地址 0xdcfF4B7A4B4a13D350A4C8E834E28EE62f27474d

// SPD 地址 0x199a46F45BF702Da3BA214599D6925A89308c439

// 已经转了 测试 u 到 founder 地址，添加 测试 U 地址到钱包 即可 转测试


// chain id 1337 test token
// export const USDT = ['0x53D6167f8c8d1A4685c61EA9A643fEEAD6161345', 18, 'USDT']
// export const CVC = ['0x447362cCE2a90c6CFD6Bf5A957F96b16B94735AB', 18, 'CVC']
// export const SPD = ['0x572A28db8d6cacDc6b4B815B2Bf300E0BF7c4e33', 18, 'SPD']
// export const Treasury = '0x8De0706438E7DF43e11474bB4150eA932BEef43E'

// // chain id 56 test token
// export const USDT = ['0x2c77609fF9B32202B68Db2AE47fde27e611B3d2f', 18, 'USDT']
// export const CVC = ['0xf285E46101913328d0CeC56601cb710a64C5838b', 18, 'CVC']
// export const SPD = ['0x42525d70c30a957D523a931d167F05Aafff4d7fC', 18, 'SPD']
// export const Treasury = '0xD48410a6A55a779B8A0dc64b08Cf33667d8693c9'

// chain id 56 production token
export const USDT_MAIN = ['0x55d398326f99059fF775485246999027B3197955', 18, 'USDT']
export const SPD = ['0x199a46F45BF702Da3BA214599D6925A89308c439', 18, 'SPD']
export const Treasury = '0x283411B3EEE4F11622feD0F428336b4A5BeA28f7'







export const BNB_USDT = '0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE'

export const SilverAddress = '0x0A00DaAE795dC3b3f2b8a3A8dD251D95FC5648fb' 

export const MultiCallAddress = '0x6E25E2E9d89d1Ba697B912599490268Ec0ec0724'

// pool: '0x456ebe26E27d2BAAF69D10dAcb5093B6A03649a5',
//   cvc: '0x46C5D9aA4bdbB3276bb9Aec04c2F66851e1D0998',
//   spd: '0xf65d042429480ab0acFEd8c968461bA1d39929af',
//   usdt: '0x5cfE6990bC4c04F598Fb1Bd2818ADEdD9d82D0f2'

export const USD = [USD_ADDRESS, 18, 'USD', 'USD Coin']
export const USD2 = [USD2_ADDRESS, 18, 'USD2', 'USD Coin 2']

export const USDT = ['0x55d398326f99059fF775485246999027B3197955', 18, 'USDT', 'Tether (USDT)']
export const CVC = ['0xB45e6Dd851df10961D1aAD912BaF220168FCAA25', 18, 'CVC', 'Contribution value Coin']
export const USDT_CVC = "0xCA300f8115413051202111E82C99A06916cE8d5a"
export const MA = '0xC34b2f8b2BF3ba4E11c5FF664642DC48Bb29F47d'

export const CVCD = ['0xBA12E794a3d9dbe504b424a80C08af0aCeB50b81', 18, 'CVCD', 'USD  CVC']

export const AI_TOKEN = ['0x080Ce7C2a34C686d842C38E23be070B3d6C52275', 15, 'AI Token']

export const TREASURY = "0x9fa39BEF94b6696182134803cBFC7B00f530ff78"

export const SWAP = "0x83605B1a90D4529bc8cFa77eABFd16fcc720BA10"

export const SENDS = "0xAca12291C47f7487d03394442b59aeD7FA930473"



// // fork
// export const USDT = ['0x5C78871053845084f24FFfe5Fd009DDD0Ef77A8c', 18, 'USDT', 'Tether (USDT)']
// export const CVC = ['0xfAe8763c234aEfCF98dEF25d57Cf7C73E4EBD066', 18, 'CVC', 'Contribution value Coin']
// export const USDT_CVC = "0x548D4e3Ef84601443ed8253306ac824Bff64a378"
// export const MA = '0xA016DeEe9ed907bE0A737d4Fc6fE25B4D340c888'
export const STABLE_COIN_LIST = [
    [USDT, 1],
    [CVCD, 1],
    [USD, 1],
    [USD2, 1]
]

export const BALANCE_LIST = [
    USDT,
    CVC,
    CVCD,
    USD,
    USD2
]

export const PRICE_LIST = [
    [CVC, USDT],
    [WBNB, USDT_MAIN],
]